export default "__VITE_ASSET__BL1wwIu7__"